module.exports = __webpack_public_path__ + "static/media/colorSilver.8965e081.png";